import React from "react";
import FileIcon from "../images/file.svg";
import Document from "../images/document2.svg";
import QuestionSheet from "../images/QuestionSheet.svg";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const steps = [
  {
    num: 1,
    side: "left",
    title: "Formular ausfüllen",
    desc: "Wenige Angaben zu Ihrer Situation, Ihrem Kanton und dem Steuerjahr — in unter 2 Minuten erledigt.",
    icon: QuestionSheet,
  },
  {
    num: 2,
    side: "right",
    title: "Persönliche Prüfung ",
    desc: "Unser Steuerexperte analysiert Ihren Fall, stellt gezielte Rückfragen und erstellt Ihre kantonsgerechte Erklärung.",
    icon: Document,
  },
  {
    num: 3,
    side: "left",
    title: " Eingereicht & dokumentiert ",
    desc: "Sie erhalten die vollständige Steuererklärung zur Freigabe — transparent, nachvollziehbar und fristgerecht eingereicht.",
    icon: FileIcon,
  },
];

export default function HowItWorks() {
  const { t } = useTranslation();

  // Variants for individual steps
  const cardVariants = {
    hidden: (side) => ({
      opacity: 0,
      x: side === "left" ? -70 : 70,
    }),
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.7, ease: "easeOut" },
    },
  };

  return (
    <section
      id="how-it-works"
      className="w-full bg-[#F0F9FF] px-4 md:px-10 py-16 overflow-hidden"
    >
      <div className="max-w-[1536px] mx-auto flex flex-col gap-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.5 }}
          className="text-center"
        >
          <h2
            className="font-bold font-poppins text-dark"
            style={{ fontSize: "clamp(24px, 3.5vw, 36px)" }}
          >
            {t("How it works")}
            {/* So funktioniert's */}

          </h2>
        </motion.div>

        <div className="flex flex-col items-center w-full max-w-2xl mx-auto">
          {steps.map((step, i) => (
            <div key={step.num} className="flex flex-col items-center w-full">
              <motion.div
                custom={step.side}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }} // Triggers when 30% of card is visible
                variants={cardVariants}
                className={`flex items-center gap-2 lg:gap-4 w-full ${step.side === "right" ? "flex-col lg:flex-row-reverse" : "flex-col lg:flex-row"}`}
              >
                {/* Step Number */}
                <div className="w-10 h-10 rounded-lg bg-[#007AB7] text-white font-poppins font-bold text-base flex items-center justify-center shrink-0 shadow-md">
                  {step.num}
                </div>

                {/* Card */}
                <motion.div
                  whileHover={{
                    y: -3,
                    shadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
                  }}
                  style={{
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
                  }}
                  className={`flex-1 bg-white rounded-xl px-5 py-4 flex items-start gap-4  ${step.side === "right" ? "flex-row-reverse text-right" : "flex-row"}`}
                >
                  <img
                    className="w-12 h-12 bg-[#E0F2FE] rounded-lg p-2 shrink-0"
                    src={step.icon}
                    alt=""
                  />
                  <div className="flex flex-col gap-1">
                    <h3 className="font-poppins font-semibold text-dark text-[15px]">
                      {t(step.title)}
                    </h3>
                    <p className="font-sans text-sm text-[#475569]">
                      {t(step.desc)}
                    </p>
                  </div>
                </motion.div>
              </motion.div>

              {/* Connector Line */}
              {i < steps.length - 1 && (
                <motion.div
                  initial={{ scaleY: 0 }}
                  whileInView={{ scaleY: 1 }}
                  viewport={{ once: false }}
                  transition={{ duration: 0.4, delay: 0.2 }}
                  style={{ originY: 0 }}
                  className="w-0.5 h-12 bg-amber"
                />
              )}
            </div>
          ))}
        </div>

        {/* Footer Button */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          className="flex justify-center mt-4">
          <motion.a
            href="#questionnaire"
            whileHover={{ scale: 1.05 }} // Sirf ek simple hover effect
            whileTap={{ scale: 0.95 }}
            className="inline-flex items-center gap-2 bg-[#007AB7] hover:bg-[#005f8d] text-white font-poppins font-semibold text-sm px-8 py-3.5 rounded-lg no-underline shadow-lg">
            {t("Start Questionnaire")}
            <ArrowRight size={18} />
          </motion.a>
        </motion.div> */}
      </div>
    </section>
  );
}